import { memo } from 'react';
import { DataTableSkeleton } from '../components/DataTable';
import { ROLES_COLUMNS, ROLES_TABLE_MIN_WIDTH } from './RolesTable';

export const RolesTableSkeleton = memo(function RolesTableSkeleton() {
  return <DataTableSkeleton columns={ROLES_COLUMNS} rows={5} minWidth={ROLES_TABLE_MIN_WIDTH} />;
});

export default RolesTableSkeleton;
